package one.healthium.onboarding.ui.screens

import androidx.compose.runtime.Composable
import one.healthium.domain.user.models.Gender
import one.healthium.onboarding.domain.configs.GenderScreenConfig
import one.healthium.onboarding.ui.UserDataProvider
import one.healthium.onboarding.ui.components.SelectableContent
import one.healthium.ui.compose.components.AppScaffold

interface GenderEventDelegate {
    fun onNextClicked()
}

@Composable
internal fun GenderScreen(
    eventDelegate: GenderEventDelegate,
    screenConfig: GenderScreenConfig,
) {
    UserDataProvider { userState, contract ->
        AppScaffold {
            SelectableContent(
                title = screenConfig.title,
                subtitle = screenConfig.subtitle,
                options = screenConfig.options,
                selectedOptions = screenConfig.options.filter {
                    it.key == userState.gender?.key
                },
                singleChoice = true,
                ctaTitle = screenConfig.ctaTitle,
                userState = userState,
                onOptionsChanged = {
                    contract.onGenderChanged(it.firstOrNull()?.key.let(Gender.Companion::fromKey))
                },
                onNextClicked = eventDelegate::onNextClicked,
                signInEnabled = false,
                onSignInClicked = {},
            )
        }
    }
}
